import React from 'react'
import { Link } from 'gatsby'
import { useIntl, FormattedMessage } from 'react-intl'

import { ageGroups } from '~data/age-groups'

const Breadcrumbs = ({ title, type, primaryTopics = [], secondaryTopics }) => {
  const { locale, messages } = useIntl()
  const key = locale.toLowerCase()

  let page = ''
  let sectionTitle = ''
  let sectionUri = ''
  let currentTitle = ''
  let ages = []
  primaryTopics.filter(({ slug }) => ageGroups.includes(slug)).forEach(age => ages.push(age.name))

  switch (type) {
    case 'Activity':
      sectionTitle = messages['activities-and-more']
      sectionUri = 'activities'
      currentTitle = title
      break
    case 'Article':
      sectionTitle = messages['browse-by-ages']
      sectionUri = 'topics'
      currentTitle = ages.length > 0 ? ages.join(' + ') : messages['all-ages']
      break
    case 'Book':
      sectionTitle = messages['activities-and-more']
      sectionUri = 'activities'
      currentTitle = title
      break
    case 'Video':
      sectionTitle = messages['videos']
      sectionUri = 'videos'
      currentTitle = secondaryTopics?.[0]?.name || title
      break
    case 'Service':
      sectionTitle = messages['find-help']
      sectionUri = 'services'
      currentTitle = title
      break
    default:
      sectionTitle = messages['explore-topics']
      sectionUri = 'topics'
      currentTitle = ages.length > 0 ? ages.join(' + ') : messages['all-ages']
  }

  return (
    <div className='font-nunito font-bold text-xs lg:text-base text-gray-dark leading-loose'>
      <Link to={`/${key}/`} className='text-blue border-blue border-b-2'>
        <FormattedMessage id='home' />
      </Link>
      <span className='mx-2 lg:mx-4' aria-hidden>
        /
      </span>
      {type !== 'Article' && type !== 'Topic' ? (
        <Link to={`/${key}/${sectionUri}/`} className='text-blue border-blue border-b-2'>
          {sectionTitle}
        </Link>
      ) : (
        <span className='text-blue border-blue border-b-2'>{sectionTitle}</span>
      )}
      <span className='mx-2 lg:mx-4' aria-hidden>
        /
      </span>
      <span className='px-2 py-1 bg-cyan-dark text-black'>{currentTitle}</span>
    </div>
  )
}

export default Breadcrumbs
